/**
 * לוג פעולות סל בצד הלקוח — קונסול + שמירה מקומית (לדיבאג תלונות).
 * לוג שרת נשמר בנפרד ב-logs/cart-*.log דרך ה-API.
 */

const STORAGE_KEY = "reshet_cart_client_audit";
const MAX_ENTRIES = 300;

function safeParse(raw) {
  try {
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

function productIdOf(itemOrId) {
  if (itemOrId == null) return null;
  if (typeof itemOrId !== "object") return String(itemOrId);
  return String(
    itemOrId.product_id?._id ??
      itemOrId.product_id?.id ??
      itemOrId.product_id ??
      itemOrId.product?._id ??
      itemOrId._id ??
      ""
  ) || null;
}

/**
 * @param {"add"|"update"|"remove"|"sync"|"merge"|"clear"} action
 * @param {object} details
 */
export function logCartClient(action, details = {}) {
  try {
    const row = {
      action,
      at: new Date().toISOString(),
      online: typeof navigator !== "undefined" ? navigator.onLine : null,
      store_id: details.store_id != null ? String(details.store_id) : null,
      product_id: details.product_id != null ? String(details.product_id) : productIdOf(details.item),
      product_name:
        details.product_name ??
        details.item?.product_id?.name ??
        details.item?.product?.name ??
        null,
      quantity_before: details.quantity_before ?? null,
      quantity_after: details.quantity_after ?? null,
      reason: details.reason ?? null,
      source: details.source ?? null,
      meta: details.meta ?? undefined,
    };

    const line = `[cartClient] ${action} ${JSON.stringify(row)}`;
    if (action === "remove") console.warn(line);
    else console.info(line);

    if (typeof localStorage === "undefined") return;
    const prev = safeParse(localStorage.getItem(STORAGE_KEY));
    prev.push(row);
    while (prev.length > MAX_ENTRIES) prev.shift();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prev));
  } catch (e) {
    console.warn("[cartClientLog] failed", e?.message || e);
  }
}

export function getCartClientLogs() {
  try {
    if (typeof localStorage === "undefined") return [];
    return safeParse(localStorage.getItem(STORAGE_KEY));
  } catch {
    return [];
  }
}

// גישה מהירה בדיבאג: בקונסול → getCartClientLogs()
if (typeof window !== "undefined") {
  window.getCartClientLogs = getCartClientLogs;
}
